<script setup>
// BonBoZ: thẻ generic của Messenger. Payload thô do builder giữ lại trong
// `content_attributes['fb_template']` (xem app/builders/messages/messenger/
// message_builder.rb). Đo trên 113 thẻ thật ở log webhook: tất cả đều `generic`,
// đúng một element, và chia làm hai kiểu — thẻ opt-in "Ưu đãi và thông báo" có
// nút, thẻ link (JD tuyển dụng, Google Maps) có ảnh + `default_action`.
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseBubble from './Base.vue';
import Icon from 'next/icon/Icon.vue';
import { useMessageContext } from '../provider.js';

const { contentAttributes } = useMessageContext();
const { t } = useI18n();

// Meta cho tối đa 10 element (carousel). Thực tế mới gặp 1, nhưng duyệt hết thì
// khỏi hỏng ngày nó gửi nhiều.
const elements = computed(
  () => contentAttributes.value?.fbTemplate?.elements ?? []
);

// Ảnh hỏng thì giấu đi, đừng để khung vỡ. fbcdn/pancake đều là URL có hạn.
const anhHong = ref([]);
</script>

<template>
  <BaseBubble
    class="p-0 w-[min(300px,calc(100cqw-5rem))] overflow-hidden"
    data-bubble-name="fb-template-card"
  >
    <div
      v-for="(element, i) in elements"
      :key="i"
      class="border-b last:border-b-0 border-n-alpha-black1"
    >
      <component
        :is="element.defaultAction?.url ? 'a' : 'div'"
        :href="element.defaultAction?.url"
        :target="element.defaultAction?.url ? '_blank' : null"
        rel="noopener noreferrer"
        class="block"
      >
        <img
          v-if="element.imageUrl && !anhHong.includes(i)"
          :src="element.imageUrl"
          alt=""
          loading="lazy"
          decoding="async"
          class="object-cover w-full h-[157px]"
          @error="anhHong.push(i)"
        />
        <div class="flex flex-col gap-0.5 p-3">
          <span v-if="element.title" class="font-medium line-clamp-2">
            {{ element.title }}
          </span>
          <span
            v-if="element.subtitle"
            class="text-sm whitespace-pre-line text-n-slate-11"
          >
            {{ element.subtitle }}
          </span>
          <span
            v-if="element.defaultAction?.url"
            class="flex gap-1 items-center mt-1 text-xs truncate text-n-blue-11"
          >
            <Icon icon="i-lucide-external-link" class="size-3 shrink-0" />
            {{ element.defaultAction.url }}
          </span>
        </div>
      </component>

      <!-- Nút chỉ để nhìn: 0/113 nút bắt được có `type` hay `url`, chúng là nút
           postback của khách bấm trong Messenger — Send API không có cách bấm hộ.
           Co vừa chữ chứ không kéo hết bề ngang: nhìn là biết cái nút. -->
      <div
        v-if="element.buttons?.length"
        class="flex flex-col gap-1 items-center px-3 pb-3"
      >
        <button
          v-for="(button, j) in element.buttons"
          :key="j"
          type="button"
          disabled
          :title="t('BONBOZ.TIN_NHAN.THE_FB_NUT_CHET')"
          class="px-4 py-1.5 max-w-full text-sm font-medium truncate rounded-full border cursor-default border-n-alpha-black2 bg-n-alpha-black1 text-n-slate-11"
        >
          {{ button.title }}
        </button>
      </div>
    </div>
  </BaseBubble>
</template>
